/**************************************************************************
 * Using the language-tags package, which uses data from the IANA Language
 * Subtag Registry:
 * https://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
***************************************************************************/

import tags from "language-tags";

/**
 * Compiles an array of languages from the registry that do not necessarily use
 * spaces to delimit words
 * @return {string[]}
 */
const nonSpaceDelimitingLangs = (function () {
	// Specific individual language tags
	let langs = [
		"ban",
		"bo",
		"cja",
		"ja",
		"jv",
		"ko",
		"lo",
		"nod",
		"ojp",
		"okm",
		"oko",
		"th",
		"vai",
		"zh"
	];

	// Get all languages with multiple tags by searching descriptions
	const langDescriptions = [
		"Batak",
		"Burmese",
		"Khmer"
	];
	langDescriptions.forEach(lang => {
		const tempTags = tags.search(lang).map(tag => tag.format());
		langs = langs.concat(tempTags);
	});

	// Get all languages that are part of macrolanguages
	const macrolanguages = [
		"zh"
	];
	macrolanguages.forEach(lang => {
		const tempTags = tags.languages(lang).map(tag => tag.format());
		langs = langs.concat(tempTags);
	});

	return langs;
})();

/**
 * Process the language tag acquired from the browser so that it can be matched
 * to generated arrays easily
 * @param {string} lang
 * @return {string}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'lang' implicitly has an 'any' type.
function processLangugageTag(lang) {
	if (lang === "unknown")
		return "en";
	else if (lang.includes("-"))
		return lang.split("-")[0];
	else
		return lang;
}

/**
 * Determines whether we should try to automatically complete highlighting
 * the entire word for the user, based on the language
 * @return {boolean}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'lang' implicitly has an 'any' type.
function shouldCompleteWordSelection(lang) {
	// Languages where words are separated by spaces should auto-complete highlight
	return !nonSpaceDelimitingLangs.includes(lang);
}

/**
 * Determines whether we should require a minimum word/character selection
 * to bring up the topics menu normally, based on the language
 * @return {boolean}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'lang' implicitly has an 'any' type.
function shouldRequireMinSelection(lang) {
	// Languages where words are separated by spaces require a minimum word selection
	return !nonSpaceDelimitingLangs.includes(lang);
}

// @ts-expect-error TS(7006) FIXME: Parameter 'lang' implicitly has an 'any' type.
function getLanguageRules(lang) {
	const highlightLang = processLangugageTag(lang);

	const languageRules = {
		shouldRequireMinSelection:   shouldRequireMinSelection(highlightLang),
		shouldCompleteWordSelection: shouldCompleteWordSelection(highlightLang)
	};

	return languageRules;
}

export default {
	getLanguageRules,
	nonSpaceDelimitingLangs,
	processLangugageTag,
	shouldCompleteWordSelection,
	shouldRequireMinSelection
};
